/** 첫 페인트 이후 비필수 작업(API 초기화 등)을 지연 실행 */
export const scheduleIdleTask = (task: () => void, timeoutMs = 2000): void => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => task(), { timeout: timeoutMs });
    return;
  }
  window.setTimeout(task, 1);
};
